import http from "./http-common";
import Crypto from "./Crypto";
import { getServidor } from "../utils/Utils";

/**
 * Clase del servicio de configuraciones que permite consultar, almacenar y actualizar.
 */

class ConfiguracionesDataService{
  
    /** 
     * @brief Obtiene todas las configuraciones registradas.
     * @returns {Promise<AxiosResponse<any>>} Lista de configuraciones en formato JSON
     */
    getAll() {
        return http.get(`${getServidor()}/configuraciones/`);
    }
    /**
     * @brief Método que permite agregar configuraciones
     * @param data Datos de la configuracion a crear.
     * @param key Clave utilizada para encriptar los datos antes de enviarlos al servidor.
     * @returns {Promise<AxiosResponse<any>>} Repuesta HTTP de la creación de la configuracion.
     */
    async create(data, key){
      const datosEncriptados = await Crypto.encriptar(data, key);
      return http.post(`${getServidor()}/configuraciones/`, datosEncriptados)
    }

    /**
     * @brief Método que permite modificar los datos de las configuraciones
     * @param data Datos de la configuracion que se desea actualizar.
     * @param key Clave utilizada para encriptar los datos antes de enviarlos al servidor.
     * @returns {Promise<AxiosResponde<any>>} Respuesta HTTP de la actualización de la configuracion.
     */
    async update(data, key){
      const datosEncriptados = await Crypto.encriptar(data, key);
      return http.put(`${getServidor()}/configuraciones/`, datosEncriptados)
    }
}
/**
 * @brief Instancia del servicio de configuraciones.
 * @type {ConfiguracionesDataService}
 */
export default new ConfiguracionesDataService();